import React from "react";
import _ from "lodash";

import { classNames, withPrefix, markdownify } from "../utils";
import SectionActions from "./SectionActions";

export default class ProjectsSection extends React.Component {
  render() {
    let section = _.get(this.props, "section", null);
    return (
      <section className="section section--features">
        {_.get(section, "title", null) && (
          <div className="container container--md align-center">
            <h2 className="section__title">{_.get(section, "title", null)}</h2>
          </div>
        )}
        <div className="container container--lg">
          {_.map(_.get(section, "projects", null), (project, project_idx) => (
            <div
              key={project_idx}
              className={classNames(
                "flex",
                "flex--middle",
                "flex--center",
                "flex--col-2",
                {
                  "align-center": _.get(project, "align", null) === "center",
                  "align-right": _.get(project, "align", null) === "right",
                }
              )}
            >
              {_.get(project, "image", null) && (
                <div
                  className={classNames("cell", "section__media", {
                    "section__media--right":
                      _.get(project, "image_position", null) === "right",
                  })}
                >
                  <img
                    src={withPrefix(_.get(project, "image", null))}
                    alt={_.get(project, "title", null)}
                  />
                </div>
              )}
              <div className="section__body cell">
                {_.get(project, "title", null) &&
                  (_.get(section, "title", null) ? (
                    <h3 className="section__title">
                      {_.get(project, "title", null)}
                    </h3>
                  ) : (
                    <h2 className="section__title">
                      {_.get(project, "title", null)}
                    </h2>
                  ))}
                {_.get(project, "content", null) && (
                  <div className="section__copy">
                    {markdownify(_.get(project, "content", null))}
                  </div>
                )}
                {_.get(project, "actions", null) && (
                  <div className="section__actions btn-group">
                    <SectionActions
                      {...this.props}
                      actions={_.get(project, "actions", null)}
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  }
}
